export default __webpack_public_path__ + "static/faq-85b9aeaf8a6d88545e16363bf7f3c335.png";